import React, { useState } from "react";
import "./BookingNotes.scss";

const BookingNotes = (props) => {
  const [notes, setNotes] = useState(props.value);

  const handleChange = (val) => {
    setNotes(val);
  };

  return (
    <div className="BookingNotes">
      <p>Meddela utföraren om något särskilt.</p>
      <textarea
        placeholder="Write booking notes..."
        value={notes}
        onChange={(e) => handleChange(e.target.value)}
      />
      <div
        className="termsBottom"
        onClick={() => {
          props.onSave();
          props.onChange(notes);
        }}
      >
        <button>Spara</button>
      </div>
    </div>
  );
};

export default BookingNotes;
